module.exports = __webpack_public_path__ + "static/Collier-727bc65c7da87ba3b3fc4d4a67184066.png";